import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input, NgZone } from '@angular/core';
import { Enclosure } from 'src/app/models/enclosure.model';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { IonInfiniteScroll, Platform } from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Skeleton } from 'src/app/models/skeleton.model';
import { FileHelpersService } from 'src/app/core/services/file-helpers/file-helpers.service';

@Component({
  selector: 'cc-enclosure-list',
  templateUrl: './enclosure-list.component.html',
  styleUrls: ['./enclosure-list.component.scss'],
})
export class EnclosureListComponent implements OnInit {

  public enclosures: Enclosure[] = [];
  private nextPage: number = 1;
  public httpError: string = null;
  public total: number;
  private searchParam: string = '';
  public showLoader: boolean = false;
  public showSkeleton: boolean = true;
  private unitParams;
  public blueprint: string = null;
  public selectedEnclosureId: number = null;
  public downloadedBlueprint;
  public printLoader: boolean = true;
  public skeleton: Skeleton = {
    show: true
  }

  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  @Output() selected = new EventEmitter<any>();
  @Input() company: string = '';

  constructor(
    private requestCreationService: RequestCreationService,
    private utils: UtilsService,
    private keyboard: Keyboard,
    private fileService: FileHelpersService,
    private platform: Platform,
    private ngZone: NgZone,
    private translate : TranslateService
  ) { }

  async ngOnInit() {
    this.unitParams = await this.utils.getFromStorage('unitParams');
    let unitInfo = await this.utils.getFromStorage('unitInfo');
    this.blueprint = unitInfo.unitImage;
    this.getEnclosures();

    if (unitInfo.unitImage) {
      try {
        this.downloadedBlueprint = await this.utils.getFromStorage(`unitDownloadedBlueprint[${unitInfo.id}]`)
      } catch (e) {
        if (e) {
          if (this.platform.is('android') || this.platform.is('ios')) {
            const fileExtension = unitInfo.unitImage.substring(unitInfo.unitImage.lastIndexOf("."), unitInfo.unitImage.lastIndexOf('?'));
            this.downloadedBlueprint = await this.fileService.downloadFiles([{
              url: unitInfo.unitImage,
              nombre: `plano${unitInfo.id}${fileExtension}`
            }]);
            this.downloadedBlueprint = this.downloadedBlueprint[0];
            await this.utils.saveInStorage(`unitDownloadedBlueprint[${unitInfo.id}]`, this.downloadedBlueprint)
          }
        }
      }
    }
  }

  async getEnclosures(ev?, search?) {
    let loader;
    if (search) {
      this.showLoader = true;
    }
    this.requestCreationService.getEnclosures(this.company, this.unitParams, this.nextPage, search)
      .subscribe(async ({ data, current_page, total, error, operation }: { data: Enclosure[], current_page: number, total: number, error, operation: string }) => {
        this.showLoader = false;
        this.skeleton.show = false;
        if (loader)
          loader.dismiss();
        if (error) {
          this.httpError = operation;
          this.utils.showMessage(operation);
        } else {
          this.httpError = null;
          this.ngZone.run(() => {
            this.enclosures.push(...data);
            setTimeout(() => {
              this.utils.updateSlide.emit();
            }, 100);
          });
          this.total = total;
        }

        if (ev) {
          ev.target.complete();
          if (this.enclosures.length == total)
            ev.target.disabled = true;
        }

      });
  }

  retry() {
    this.skeleton.show = true;
    this.getEnclosures();
  }

  search({ detail: { value } }) {
    this.nextPage = 1;
    if (value.length > 1) {
      this.enclosures = [];
      this.getEnclosures(null, value);
      this.searchParam = value;
    } else if (value.length === 0) {
      this.cleanSearch();
    }
  }

  cleanSearch() {
    this.keyboard.hide();
    this.enclosures = [];
    this.showSkeleton = true;
    this.searchParam = ''
    this.skeleton.show = true;
    this.getEnclosures();
  }

  loadMore(ev) {
    this.nextPage++;
    if (this.searchParam) {
      this.getEnclosures(ev, this.searchParam);
    }
    else
      this.getEnclosures(ev);
  }

  selectEnclosure(enclosureId) {
    this.selectedEnclosureId = enclosureId;
    this.selected.emit(this.enclosures.find((el: Enclosure) => enclosureId === el.id));
  }


  async openBlueprint() {
    if (this.downloadedBlueprint)
      this.fileService.openFile(this.downloadedBlueprint);
  }

}
